import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface tasksState {
  h5LoginType: any;
  bscWalletAddress: string,
  loginState: boolean
}

const initialState: tasksState = {
  h5LoginType: {},
  bscWalletAddress: "",
  loginState: false
}
const createStore = createSlice({
  name: 'h5Login',
  initialState,
  reducers: {
    changeH5Login(state, action: PayloadAction<any>) {
      state.h5LoginType = action.payload
    },
    changeBscWalletAddress(state, action: PayloadAction<any>) {
      state.bscWalletAddress = action.payload
    },
    changeLoginState(state, action: PayloadAction<any>) {
      state.loginState = action.payload
    }


  }
})

export const { changeLoginState, changeH5Login, changeBscWalletAddress } = createStore.actions

export default createStore.reducer